import React from 'react';
import logo from './logo.svg';
import {BrowserRouter as Router, Route, Switch} from "react-router-dom"
import history from "./tools/history";
import ApiLayer from './components/ApiLayer'
import UntappdDataLayer from './components/UntappdDataLayer'
import './App.css';

function App() {
  return (
    <div className="App">
      <Router history={history}>
        <Switch>
          <Route 
            path="/" render={(routeProps) => (
              <ApiLayer {...routeProps} />
            )}
          />
          
        </Switch>
       
      </Router>
    </div>
  );
}

export default App;
